<template>
  <el-tooltip
    placement="right"
    :effect="$theme.tooltipKey()"
    popper-class="common-panel-right-tooltip-box"
    :disabled="disabled"
    :open-delay="350"
    transition="">
    <div slot="content">
      <div
        class="attr-list-box"
        v-if="attrInfo && !disabled">
        <div class="attr-item-box">
          <div class="label dialog-label">数据名称：</div>
          <div
            class="value text-overflow dialog-label"
            :title="attrInfo.name">{{attrInfo.name }}
          </div>
        </div>
        <div v-if="!attrInfo?.showOnlyName">
          <div
            class="attr-item-box"
            v-if="attrInfo.attrType === 'dataSet'">
            <div class="label dialog-label">数据类型：</div>
            <div
              class="value dialog-label"
              :title="attrInfo.dataType">{{attrInfo.dataType }}
            </div>
          </div>
          <div
            class="attr-item-box"
            v-if="attrInfo.attrType === 'elem'">
            <div class="label dialog-label">源文件：</div>
            <div
              class="value text-overflow dialog-label"
              :title="attrInfo.srcName">{{attrInfo.srcName }}
            </div>
          </div>
          <div class="attr-item-box">
            <div class="label dialog-label">大小：</div>
            <div class="value dialog-label">{{`${formatFileSize(attrInfo.length).fileSize}${
                  formatFileSize(attrInfo.length).unit
                }`
              }}
            </div>
          </div>
          <div
            class="attr-item-box"
            v-if="attrInfo.attrType === 'elem'">
            <div class="label dialog-label">格式：</div>
            <div
              class="value dialog-label"
              :title="attrInfo.fileType">{{attrInfo.fileType }}
            </div>
          </div>
          <div
            class="attr-item-box"
            v-if="attrInfo.attrType === 'dataSet'">
            <div class="label dialog-label">路径：</div>
            <div
              class="value text-overflow dialog-label"
              :title="attrInfo.path">{{attrInfo.path }}
            </div>
          </div>
          <div
            class="attr-item-box"
            v-if="attrInfo.attrType === 'dataSet'">
            <div class="label dialog-label">数据源：</div>
            <div
              class="value text-overflow dialog-label"
              :title="attrInfo.sourcePath">{{attrInfo.sourcePath }}
            </div>
          </div>
          <div
            class="attr-item-box"
            v-if="attrInfo.attrType === 'dataSet'">
            <div class="label dialog-label">子项：</div>
            <div class="value sub-item-box">
              <div
                class="sub-item text-overflow dialog-label"
                v-for="(item, index) in attrInfo.subItems"
                :key="index"
                :title="item">{{item }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <slot></slot>
  </el-tooltip>
</template>

<script>
import { formatFileSize } from '@/utils/generalMethods'
export default {
  data() {
    return {}
  },
  props: {
    disabled: Boolean,
    attrInfo: Object
  },
  methods: {
    formatFileSize
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.attr-list-box {
  padding: 8px;
  border-radius: 8px;
  .attr-item-box {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;

    .label {
      flex-shrink: 0;
      text-align: left;
      color: var(--tooltip-text-label-color);
      font-size: 14px;
      font-weight: 400;
    }

    .value {
      flex-grow: 1;
      font-size: 13px;
      font-weight: 300;
      line-height: 20px;
      color: var(--tooltip-text-value-color);
      white-space: break-spaces;
      word-break: break-all;
    }

    .sub-item-box {
      white-space: break-spaces;
      overflow-y: auto;
      max-height: 300px;
      color: var(--tooltip-text-value-color);
      .sub-item {
        color: var(--tooltip-text-value-color);
      }
    }
  }
}
</style>
